if (!customElements.get('announcement-rotator')) {
  customElements.define(
    'announcement-rotator',
    class AnnouncementRotator extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.slides = this.querySelectorAll('.announcement-rotator__slide');
        if (this.slides.length < 2) return;

        this.current = Math.max(
          0,
          Array.from(this.slides).findIndex((slide) => slide.classList.contains('is-active'))
        );
        const interval = parseInt(this.dataset.interval, 10) || 3500;
        this.timer = setInterval(() => this.next(), interval);
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }

      next() {
        this.slides[this.current].classList.remove('is-active');
        this.current = (this.current + 1) % this.slides.length;
        this.slides[this.current].classList.add('is-active');
      }
    }
  );
}
